import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link, withRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import blogPlaceholderImgPath from "../../../../assets/img/blog-placeholder.jpg";

const BlogCard = (props) => {
  const { t, i18n } = useTranslation();
  const [selectedLang, setSelectedLang] = useState();
  const [blogImgPath, setBlogImgPath] = useState(blogPlaceholderImgPath);
  const languages = useSelector((state) => state.main.availableLanguages);
  const blog = props.blog;

  useEffect(() => {
    if (blog.img_url) {
      setBlogImgPath(blog.img_url);
    }
    setSelectedLang(languages[i18n.language]);
  }, [languages, i18n.language, selectedLang, blog.img_url]);

  return (
    <Fragment>
      <div key={blog.id} className="col-xl-4 col-lg-6 mb-4">
        <div className="card card-stats saa_shadow">
        <h1 className="title" style={{
          fontSize: "16px"
        }}>{t(blog.title)}</h1>
          <div className="img-wrap">
            <LazyLoadImage
              alt={t(blog.title)}
              src={blogImgPath}
              width="100%"
            />
          </div>
          <div className="info-wrap">
            <small className="desc">
              {t(blog.short_description).length > 116
                ? t(blog.short_description).substring(0, 116) + "..."
                : t(blog.short_description)}
            </small>
          </div>
          <div className="bottom-wrap">
            <Link
              to={`/${i18n.language}/blog/${blog.unique_title}`}
              className="btn btn-outline-primary btn-block"
            >
              {t("LANDING_PAGE_BLOG_MORE_BTN_LABEL")}
            </Link>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default withRouter(BlogCard);
